<div class="access-notice">
  <p>
    Du hast leider keine Rolle in der App. Wenn du denkst, dass du Zugang haben
    solltest klicke bitte auf den Knopf.
  </p>
  <a
    href="mailto:felicitas.fuhrmann@spirit-testing.com?subject=Rollen%20für%20Profiler%20beantragen&body=Ich%20hätte%20gerne%20die%20folgenden%20Rolle(n)%20für%20den%20Profiler:%20User."
    >Sende Email</a
  >
</div>
